import { Chip } from "@material-ui/core";
import { memo } from "react";
import { useContasReceberService } from "../context/ContasReceberContext";

const SituationChip = ({ situation }) => {
  const { handleRemoveChip } = useContasReceberService();

  return (
    <Chip
      key={situation.id}
      label={situation.desc}
      onDelete={() => {
        handleRemoveChip(situation);
      }}
      color={"primary"}
    />
  );
};

export default memo(SituationChip);
